/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/forbid-prop-types */
import React from 'react';

import PropTypes from 'prop-types';

import { Item } from './styles';

const LanguageItem = ({ language, switchLanguage, handleRequestClose }) => {
    const { icon, name } = language;

    return (
        <Item
            className="pointer"
            onClick={() => {
                handleRequestClose();
                switchLanguage(language);
            }}
        >
            <div className="d-flex align-items-center theme-item">
                <i className={`flag flag-24 flag-${icon}`} />
                <h4 className="mb-0 ml-2 item-name">{name}</h4>
            </div>
        </Item>
    );
};

export default LanguageItem;

LanguageItem.propTypes = {
    language: PropTypes.object.isRequired,
    switchLanguage: PropTypes.func.isRequired,
    handleRequestClose: PropTypes.func.isRequired,
};
